// extracted by mini-css-extract-plugin
export default {"App":"App_App__2+VHF","wrapper":"App_wrapper__nlASx","configWrapper":"App_configWrapper__WJjVT"};